import Lithan from "../../src/imgs/education/LithanOne.webp";
import Roehampton from "../../src/imgs/education/Roehampton.webp";

export const educationData = [
  {
    name: "Lithan Educlaas",
    title: "Pearson BTEC International Level 3 in Information Technology",
    img: Lithan,
    year: "Graduation: 2022",
    status: "completed",
  },
  {
    name: "Lithan Educlaas",
    title: "Pearson Level 5 HND Diploma in Computing",
    img: Lithan,
    year: "Graduation: 2024",
    status: "completed",
  },
  {
    name: "University of Roehampton",
    title: "BSc. in Computer Science",
    img: Roehampton,
    year: "Graduation: 2026",
    status: "completed",
  },
];
